import React, { useState } from "react";

import FormGroup from "../FormGroup";

import style from "./style.module.css";

export default function Input(props) {
    const [focus, setFocus] = useState(false);
    const { type, input: { value, onBlur, onChange }, placeholder, onKeyUpHandler, onKeyDown, disabled, maxLength, label, required, meta, helpText, autoComplete="on" } = props;

    const onBlurHandler = (e) => {
        onBlur(e);
        setTimeout(() => setFocus(false));
    }

    return (
        <FormGroup
            meta={meta}
            label={label}
            focus={focus}
            value={value}
            required={required}
            helpText={helpText}
            disabled={disabled}
        >
            <input
                type={type}
                value={value}
                placeholder={placeholder}
                onFocus={() => setFocus(true)}
                onKeyUp={onKeyUpHandler}
                onKeyDown={onKeyDown}
                disabled={disabled}
                className={`${style.textbox} ${!label ? style.noLabelPadding : ""}`}
                maxLength={maxLength}
                onBlur={onBlurHandler}
                onChange={onChange}
                autoComplete={autoComplete}
            />
        </FormGroup>
    )
}